import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black'
};
const GuardarInstalacionComponent = (props) => {

    const { guardarInstacion, agregarOtraInstalacion, unidad, validarUnidad, texto } = props

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description"  component="h2" sx={{ mt: 2 }} style={{ color: "black" }}>
                            {bodyModal}
                            {/* <center><strong>¿Desea continuar?</strong></center> */}
                        </Typography>
                        <br />
                        <div className='row col-md-12'>
                            <div className='col-md-6 text-end'>
                                <button className='btn btn-success' onClick={() => botonGuardarInstalacion('Si')}>Si</button>
                            </div>
                            <div className='col-md-6'>
                                <button className='btn btn-success' onClick={() => botonGuardarInstalacion('No')}>No</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    

    const [openModalError, setOpenModalError] = React.useState(false);
    const [titleModalError, setTitleModalError] = React.useState('');
    const [bodyModalError, setBodyModalError] = React.useState('')
    const handleOpenModalError = (data) => {
        setTitleModalError(data.title)
        setBodyModalError(data.body)
        setOpenModalError(true)
    }
    const handleCloseModalError = () => {
        setTitleModalError('')
        setBodyModalError('')
        setOpenModalError(false)
    }

    const modalComponentError = () => {
        return (
            <div>
                <Modal
                    open={openModalError}
                    onClose={handleCloseModalError}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModalError}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" , textAlign: 'justify'}}>
                            <p className='text-center'>{bodyModalError}</p>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-danger' onClick={() => handleCloseModalError() }>ACEPTAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonAgregarAnexo = async () => {
        const errores = validarUnidad()
        if (!errores) {
            handleOpenModalError({
                title: `Error`,
                body: `Rellena los campos obligatorios`,
                accion: 'agregar',
            })
        }else{
            handleOpenModal({
                title: `¿Desea agregar otra unidad de ${unidad}? `,
                body: ``,
                accion: 'agregar',
            })
        }
        
    }

    const botonGuardarInstalacion = async (accion) => {
        if(accion === 'Si'){
            agregarOtraInstalacion()
        }else if(accion === 'No'){
            guardarInstacion()
        }
        setOpenModal(false)
    }
    return (
        <Fragment>
            <button 
                onClick={botonAgregarAnexo} type='submit' className={`btn btnNaranja`}> {`${texto}`}
            </button>
            {modalComponent()}
            {modalComponentError()}
        </Fragment>
    )
};

export default withRouter(GuardarInstalacionComponent)
